import Skeleton from 'react-loading-skeleton'
import * as S from './styles'
import {
  PriceRowSkeleton,
  ProductDescriptionsWrapperSkeleton,
  ProductDetailsWrapperSkeleton,
  VariantsSliderSkeleton,
} from './styles'

const ApparelProductSkeleton = ({
  showProductType = false,
  showSingleVariant = false,
  showSeason = false,
  layout = 'card',
}: {
  layout?: 'card' | 'list'
  showProductType: boolean
  showSingleVariant?: boolean
  showSeason?: boolean
}) => {
  return (
    <S.ApparelCard layout={layout}>
      <S.Image>
        <Skeleton />
      </S.Image>

      <ProductDetailsWrapperSkeleton>
        <ProductDescriptionsWrapperSkeleton>
          {showProductType && (
            <S.ProductType>
              <Skeleton />
            </S.ProductType>
          )}
          <S.Title>
            <Skeleton />
          </S.Title>

          {showSeason && (
            <S.Season>
              <Skeleton />
            </S.Season>
          )}

          <S.Description>
            <Skeleton width="90%" />
            <Skeleton width="50%" />
          </S.Description>
        </ProductDescriptionsWrapperSkeleton>
        <PriceRowSkeleton>
          <S.Price>
            <Skeleton />
          </S.Price>
        </PriceRowSkeleton>
      </ProductDetailsWrapperSkeleton>
      {showSingleVariant && (
        <VariantsSliderSkeleton>
          {[1, 2, 3, 4, 5, 6].map((position) => {
            return (
              <Skeleton
                key={position}
                width="7rem"
                style={{
                  aspectRatio: '4/5',
                }}
              />
            )
          })}
        </VariantsSliderSkeleton>
      )}
    </S.ApparelCard>
  )
}

export default ApparelProductSkeleton
